import { getRedirectServiceUrl } from './redirect-service-url.js';
import type { RedirectServiceUrlOptions } from './redirect-service-url.js';

export function getSiteRedirectUrl(
  options: Required<RedirectServiceUrlOptions>
) {
  return getRedirectServiceUrl(options);
}
